import React from 'react'
import { Link, useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import Loading from '../../components/Loading'
import { toast } from 'react-toastify'
import { Modal } from 'react-bootstrap'
import CustomInput from '../../components/CustomInput'
import api from '../../services/api'

import DiretoriaCard from '../../components/DiretoriaCard'
import AdminMenu from '../../components/AdminMenu'
import Icon from '../../components/Icon'

export default function Diretorias() {
  const { path } = useRouteMatch()
  const history = useHistory()
  const { search } = useLocation()
  const [diretoriasList, setDiretoriasList] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const [modal, setModal] = React.useState(false)
  const [itemToDelete, setItemToDelete] = React.useState('')
  const searchRef = React.useRef()
  const [page, setPage] = React.useState(1)
  const [pages, setPages] = React.useState(0)

  async function removeItem() {
    await api.delete(`/diretorias/${itemToDelete}`)
    setDiretoriasList((oldState) => {
      return oldState.filter((item) => item?._id !== itemToDelete)
    })
    handleClose()
    toast.success('Diretoria deletada com sucesso!')
  }

  const handleClose = () => setModal(false)
  const handleShow = () => setModal(true)

  const handleSearch = React.useCallback(
    (e) => {
      e.preventDefault()
      const value = searchRef?.current?.value?.trim()

      const data = Object.assign({}, value ? { busca: value } : null)

      history.push({
        pathname: path,
        search: new URLSearchParams(data).toString(),
      })
    },
    [history, path],
  )

  const urlQuery = React.useMemo(() => {
    const queries = new URLSearchParams(search)

    const query = {}

    const busca = queries.get('busca') || ''

    if (busca) {
      query.busca = busca
    }

    return query
  }, [search])

  const hasMore = React.useMemo(() => page <= pages, [page, pages])

  React.useEffect(() => {
    ;(async () => {
      try {
        setPage(1)
        setLoading(true)
        const response = await api.get('/diretorias', {
          params: {
            search: urlQuery?.busca,
          },
        })

        setDiretoriasList(response?.data?.list)
        setPages(response?.data?.pages || 1)
      } catch (err) {
        toast.error(
          err?.response?.data?.erro ||
            'Erro ao buscar a lista de diretoria, por favor, recarregue a página.',
        )
      } finally {
        setLoading(false)
        setPage((p) => p + 1)
      }
    })()
  }, [urlQuery])

  return (
    <>
      <AdminMenu />
      {loading && <Loading delayTime={200} />}
      <main className="wrapper bg-verm" id="scrollableWrapper">
        <div className="container mt-3 p-0 pt-3 pb-4 position-relative">
          <div className="col-12 mb-4">
            <div className="card border-0 p-4">
              <Link to={`${path}/cadastrar`} className="text-decoration-none btn-adicionar">
                <Icon icon="plus" color="#fff" />
              </Link>
              <form className="form-pesquisa" onSubmit={handleSearch}>
                <CustomInput
                  value={urlQuery?.busca}
                  id="input-pesquisa"
                  placeholder="Pesquisar por diretoria"
                  icon="search"
                  sendIcon="paper-plane"
                  inputRef={searchRef}
                  hasMore={hasMore}
                  scrollableTarget="scrollableWrapper"
                />
              </form>
            </div>
          </div>
          <Link to={`${path}/cadastrar/`} className="text-decoration-none btn-adicionar mt-3 mr-3">
            <Icon icon="plus" color="#fff" />
          </Link>
          <Modal
            show={modal}
            onHide={handleClose}
            keyboard={false}
            dialogClassName="modal-90w"
          >
            <Modal.Header closeButton>
              <Modal.Title className="modal-title">Remover Membro?</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex">
              Tem certeza que deseja remover este membro? Esta ação não será
              reversível.
            </Modal.Body>
            <Modal.Footer>
              <button
                className="btn btn-verm"
                type="button"
                onClick={removeItem}
              >
                Remover
              </button>
            </Modal.Footer>
          </Modal>
          <div className="d-flex flex-wrap row-gap-30">
            {diretoriasList.length > 0 ? (
              diretoriasList?.map((diretoria) => (
                <DiretoriaCard
                  handleShow={handleShow}
                  setItemToDelete={setItemToDelete}
                  diretoria={diretoria}
                  key={diretoria?._id}
                />
              )) || <div></div>
            ) : (
              <div className="jogos_">Não há membros cadastrados.</div>
            )}
          </div>
        </div>
      </main>
    </>
  )
}
